module.exports = __webpack_public_path__ + "christmasBells.8b174b3a3f16a02b61a5.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/img/christmasBells.jpg
// module id = ../../../../../src/assets/img/christmasBells.jpg
// module chunks = main